import { useFormContext, useController, useWatch } from 'react-hook-form';
import { ICheckBox } from './ICheckBox';
import * as S from './CheckBox.styled';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { useEffect, useState } from 'react';
import { isObject } from '@core-web/lib';

const CheckBox = (props: ICheckBox): JSX.Element => {
  const {
    label,
    size,
    name,
    value = 'true',
    sx,
    defaultValue,
    onChange,
    labelPlacement,
    dependentFields,
    shouldAddErrorStateOnUncheck,
    shouldReverseValue,
    skipDefaultReset,
    checkBoxChangeColor,
    isDisabled,
    dependency,
    specificDependencyValueToDisableWith,
    padding,
    onValueChange,
    ...rest
  } = props;
  const { control, resetField, setValue, clearErrors, getValues } = useFormContext();
  const { field } = useController({
    control,
    name,
    defaultValue,
  });

  const selectedValue = useWatch({ name });
  const dependencyValue = useWatch({ name: dependency || `${name}-dependency` });
  const [shouldDisable, setShouldDisable] = useState<boolean>(false);

  useEffect(() => {
    if (dependency && specificDependencyValueToDisableWith) {
      const current = getValues(name);
      if (isObject(dependencyValue)) {
        if (dependencyValue?.value === specificDependencyValueToDisableWith) {
          if (current === true) {
            setValue(name, false);
          }
          clearErrors(name);
          setShouldDisable(true);
        } else {
          setShouldDisable(false);
        }
      } else if (dependencyValue === specificDependencyValueToDisableWith) {
        if (current === true) {
          setValue(name, false);
        }
        clearErrors(name);
        setShouldDisable(true);
      } else {
        setShouldDisable(false);
      }
    }
  }, [dependency, dependencyValue]);

  useEffect(() => {
    if (!skipDefaultReset) {
      resetField(name, { defaultValue });
    }
  }, [defaultValue, skipDefaultReset]);

  const handleChange = (event: any) => {
    field.onChange(event);
    onChange?.(event, dependentFields);
  };

  useEffect(() => {
    onValueChange?.(selectedValue, dependentFields);
  }, [selectedValue]);

  const checkCheckBoxMark = () => {
    const isBoolean = typeof field.value === 'boolean';
    const FValue = isBoolean ? field.value : !!field.value?.value;

    if (shouldReverseValue) {
      return !FValue;
    }

    return FValue;
  };

  return (
    <S.CheckboxButtonStyled
      control={
        <S.MuiCheckBox
          className={shouldAddErrorStateOnUncheck && !field.value ? 'errorBorder' : ''}
          customSize={size || 20}
          {...field}
          checked={checkCheckBoxMark()}
          value={shouldReverseValue ? !value : value}
          sx={sx}
          onChange={handleChange}
          icon={<CheckBoxOutlineBlankOutlinedIcon />}
          checkedIcon={<CheckBoxOutlinedIcon />}
          checkBoxChangeColor={checkBoxChangeColor}
          disabled={isDisabled || shouldDisable}
          padding={padding}
          {...rest}
        />
      }
      label={label}
      labelPlacement={labelPlacement || 'end'}
    />
  );
};

export default CheckBox;
